export enum ReportsInfo {
    GET_REPORT_INFO = "GET_REPORT_INFO",
    GET_REPORT_INFO_SUCCESS = "GET_REPORT_INFO_SUCCESS",
    GET_REPORT_INFO_FAIL = "GET_REPORT_INFO_FAIL"
  }  